import type { CodeBidiWarningPluginOptions } from '@atlaskit/editor-plugin-code-bidi-warning/codeBidiWarningPluginType';

export function codeBidiWarningPluginOptions(): CodeBidiWarningPluginOptions {
	return {
		appearance: 'full-page',
	};
}
